/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetThousandsFormats$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getThousandsFormatsRequest = createAction<PayloadData<void>>('GET_THOUSANDS_FORMATS__GET_THOUSANDS_FORMATS__REQUEST');
export const getThousandsFormatsSuccess = createAction<PayloadData<Array<DictionaryItem>>>('GET_THOUSANDS_FORMATS__GET_THOUSANDS_FORMATS__SUCCESS');
export const getThousandsFormatsFailure = createAction<PayloadData<Error, void, true>>('GET_THOUSANDS_FORMATS__GET_THOUSANDS_FORMATS__FAILURE');

export const getThousandsFormatsActions = [
    getThousandsFormatsRequest,
    getThousandsFormatsSuccess,
    getThousandsFormatsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getThousandsFormats = (config?: GetThousandsFormats$Config) => {
    return {
        CALL_API: {
            types: getThousandsFormatsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/thousands-formats`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

